/**
 * Turns `/url/path/` into `url-kebab`
 * @param window window element
 */
function urlKebab(window) {
    return new URL(window.location).pathname
        .split('/')             // Split on slashes
        .filter(part => part)    // Don't inlcude empty parts
        .join('-');             // Kebab-ify
}

export default urlKebab;
